import Immutable from 'seamless-immutable';
import { ProjectTask } from '../stores';
import { ProjectTaskActions } from '../actions';

const initialState = Immutable(ProjectTask);

export function projectTask(state = initialState, action) {
	switch (action.type) {
		case ProjectTaskActions.FetchProjectTasks.Request: {
			return state.merge({
				isProjectTaskListLoading: true
			});
		}
		case ProjectTaskActions.FetchProjectTasks.Success: {
			return state.merge({
				projectTasks: action.payload.items,
				isProjectTaskListLoading: false,
				totalProjectTasks: action.payload.totalItems
			});
		}
		case ProjectTaskActions.FetchProjectTasks.Failure: {
			return state.merge({
				isProjectTaskListLoading: false
			});
		}
		case ProjectTaskActions.GetProjectTask.Request: {
			return state.merge({
				isProjectTaskLoading: true
			});
		}
		case ProjectTaskActions.GetProjectTask.Success: {
			return state.merge({
				projectTask: action.payload,
				isProjectTaskLoading: false
			});
		}
		case ProjectTaskActions.GetProjectTask.Failure: {
			return state.merge({
				isProjectTaskLoading: false
			});
		}
		case ProjectTaskActions.SearchProjectTasks.Request: {
			return state.merge({
				isProjectTaskSearching: true
			});
		}
		case ProjectTaskActions.SearchProjectTasks.Success: {
			return state.merge({
				projectTasks: action.payload.items,
				isProjectTaskSearching: false,
				totalProjectTasks: action.payload.totalItems
			});
		}
		case ProjectTaskActions.SearchProjectTasks.Failure: {
			return state.merge({
				isProjectTaskSearching: false
			});
		}
		default: {
			return state;
		}
	}
}
